import { render, staticRenderFns } from "./SearchChat.vue?vue&type=template&id=7d6f8131&scoped=true"
import script from "./SearchChat.vue?vue&type=script&lang=ts"
export * from "./SearchChat.vue?vue&type=script&lang=ts"
import style0 from "./SearchChat.vue?vue&type=style&index=0&id=7d6f8131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f8131",
  null
  
)

export default component.exports